import API from '@/lib/API.js'
import comun from './comun.js'
const conveniosplanes = {
    namespaced: true,
    state: {
        Lista: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Lista = [];
            state.Seleccionado = undefined;
        },
        set(state, valor) {
            state.Lista = valor;
        },
        agregar(state, valor) {
            state.Lista.push(valor);
        },
        select(state, valor) {
            state.Seleccionado = valor;
        },
    },
    actions: {
        async traerPorPlan({
            commit
        }, valor) {
            commit("comun/cargando")
            let data = []
            data = await API.Convenios_Planes.traerPorPlan(valor);
            commit("set", data)
            commit("comun/fincarga")
        },
        select({
            commit
        }, valor) {
            commit("select", valor)
            commit("set", [])
        },
        async modificarSeleccionada({
            commit,
            state
        }) {
            try {
                let data = []
                let str = ""
                if (state.Seleccionado.id_item != 0) {
                    data = await API.Convenios_Planes.modificar(state.Seleccionado);
                    str += "Convenio modificado"
                } else {
                    data = await API.Convenios_Planes.alta(state.Seleccionado);
                    commit("agregar", data)
                    str += `Convenio dado de alta`
                }
                commit("select", data)
                commit("comun/mostrar", str)

            } catch (error) {
                alert(error)
            }
        },
        async modificarEntidad({
            commit,
            state
        }, entidad) {
            try {
                let str = ""
                if (entidad.id_item != 0) {
                    entidad = await API.Convenios_Planes.modificar(entidad);
                    str += "Convenio modificado"
                } else {
                    let data = await API.Convenios_Planes.alta(entidad);
                    commit("agregar", data)
                    str += `Convenio dado de alta`
                }
                commit("comun/mostrar", str)
                return 0;
            } catch (error) {
                alert(error)
            }
        },
    },
    modules: {
        comun,
    }

}
export default conveniosplanes;